import {Controller} from "stimulus"

import axios from 'axios'

export default class extends Controller {
    static targets = ["source", "target"]

    connect() {
    }

    handleSelectChange() {
        this.updateAddresses()
    }

    resetSelect(select) {
        var length = select.options.length;
        for (var i = length - 1; i >= 0; i--) {
            select.options[i] = null;
        }
    }

    updateAddresses() {
        var org_id = this.sourceTarget.value
        var addresses = this.targetTarget
        this.resetSelect(addresses)

        console.log(org_id)
        axios.get('/organisations/load_addresses',
            {
                params: {
                    id: org_id
                }
            })
            .then(function (response) {
                console.log( response.data)
                for (var index = 0; index < response.data.length; index++) {
                    var item = response.data[index]
                    let option = document.createElement('option')
                    option.value = item['id']
                    option.text = item['name']
                    console.log(option)
                    addresses.appendChild(option)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


}
